var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("delegation-rate-menu"),
      _c("h2", [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                "settings.delegationRate.standardDelegationRateVehicle.title"
              )
            ) +
            " "
        )
      ]),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          _c("text-field-with-copy-default-button", {
            attrs: {
              "button-tooltip": _vm.$t(
                "settings.delegationRate.standardDelegationRateVehicle.revertRate"
              ),
              "default-button": true,
              "default-value": _vm.delegationRateVehicle.defaults()
                .delegation_vehicle_under_900_rate,
              label:
                _vm.$t(
                  "settings.delegationRate.standardDelegationRateVehicle.vehicleUnder900"
                ) + "*",
              model:
                _vm.delegationRateVehicle.delegation_vehicle_under_900_rate,
              rules: _vm.delegationRateVehicle.rules()
                .delegation_vehicle_under_900_rate,
              suffix: "PLN",
              type: "number"
            },
            on: {
              "update:model": function($event) {
                return _vm.$set(
                  _vm.delegationRateVehicle,
                  "delegation_vehicle_under_900_rate",
                  $event
                )
              }
            }
          }),
          _c("text-field-with-copy-default-button", {
            attrs: {
              "button-tooltip": _vm.$t(
                "settings.delegationRate.standardDelegationRateVehicle.revertRate"
              ),
              "default-button": true,
              "default-value": _vm.delegationRateVehicle.defaults()
                .delegation_vehicle_above_900_rate,
              label:
                _vm.$t(
                  "settings.delegationRate.standardDelegationRateVehicle.vehicleAbove900"
                ) + "*",
              model:
                _vm.delegationRateVehicle.delegation_vehicle_above_900_rate,
              rules: _vm.delegationRateVehicle.rules()
                .delegation_vehicle_above_900_rate,
              suffix: "PLN",
              type: "number"
            },
            on: {
              "update:model": function($event) {
                return _vm.$set(
                  _vm.delegationRateVehicle,
                  "delegation_vehicle_above_900_rate",
                  $event
                )
              }
            }
          }),
          _c("text-field-with-copy-default-button", {
            attrs: {
              "button-tooltip": _vm.$t(
                "settings.delegationRate.standardDelegationRateVehicle.revertRate"
              ),
              "default-button": true,
              "default-value": _vm.delegationRateVehicle.defaults()
                .delegation_vehicle_moped_rate,
              label:
                _vm.$t(
                  "settings.delegationRate.standardDelegationRateVehicle.moped"
                ) + "*",
              model: _vm.delegationRateVehicle.delegation_vehicle_moped_rate,
              rules: _vm.delegationRateVehicle.rules()
                .delegation_vehicle_moped_rate,
              suffix: "PLN",
              type: "number"
            },
            on: {
              "update:model": function($event) {
                return _vm.$set(
                  _vm.delegationRateVehicle,
                  "delegation_vehicle_moped_rate",
                  $event
                )
              }
            }
          }),
          _c("text-field-with-copy-default-button", {
            attrs: {
              "button-tooltip": _vm.$t(
                "settings.delegationRate.standardDelegationRateVehicle.revertRate"
              ),
              "default-button": true,
              "default-value": _vm.delegationRateVehicle.defaults()
                .delegation_vehicle_motorcycle_rate,
              label:
                _vm.$t(
                  "settings.delegationRate.standardDelegationRateVehicle.motorcycle"
                ) + "*",
              model:
                _vm.delegationRateVehicle.delegation_vehicle_motorcycle_rate,
              rules: _vm.delegationRateVehicle.rules()
                .delegation_vehicle_motorcycle_rate,
              suffix: "PLN",
              type: "number"
            },
            on: {
              "update:model": function($event) {
                return _vm.$set(
                  _vm.delegationRateVehicle,
                  "delegation_vehicle_motorcycle_rate",
                  $event
                )
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "v-btn",
            {
              attrs: { disabled: !_vm.formValid, block: "", color: "accent" },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }